/**
 * Coins Hub — модалка «Все поддерживаемые монеты» (#modalCoins).
 * Рендерит грид, чипы-фильтры по сетям и живой поиск. Разметка модалки,
 * стили и локализация — в coins.blade.php / _coins-hub.scss / landing_coins.php.
 * Язык переключается сервером (перезагрузка страницы), поэтому здесь нет
 * словаря/localStorage — локализуемые лейблы («Все»/«Скоро») приходят из
 * data-атрибутов #modalCoins, текст «ничего не найдено» — уже в DOM.
 *
 * Монета: { s: тикер, n: имя, i: файл иконки (''=монограмма),
 * nets: [сети], soon: 1 — если интеграция в процессе }.
 */

const ICON_BASE = '/landing/coins/';

const COINS = [
  { s: 'ETH', n: 'Ethereum', i: 'EthereumETH.svg', nets: ['Arbitrum', 'BNB Chain', 'Ethereum'] },
  { s: 'USDC', n: 'USD Coin', i: 'USDCoinUSDC.svg', nets: ['Arbitrum', 'Avalanche', 'BNB Chain', 'Ethereum', 'Polygon'] },
  { s: 'USDT', n: 'Tether', i: 'TetherUSDT.svg', nets: ['Arbitrum', 'Avalanche', 'BNB Chain', 'Ethereum', 'Polygon', 'Solana', 'TON', 'Tron'] },
  { s: 'AVAX', n: 'Avalanche', i: 'AvalancheAVAX.svg', nets: ['Avalanche'] },
  { s: 'AITECH', n: 'Solidus AiTech', i: 'SolidusAitechAITECH.png', nets: ['BNB Chain'] },
  { s: 'ALICE', n: 'My Neighbor Alice', i: 'MyNeighborAliceALICE.svg', nets: ['BNB Chain'] },
  { s: 'BNB', n: 'BNB', i: 'BinanceCoinBNB.svg', nets: ['BNB Chain'] },
  { s: 'DCK', n: 'DexCheck', i: 'DexcheckDCK.png', nets: ['BNB Chain'] },
  { s: 'DEXE', n: 'DeXe', i: 'DexeDEXE.png', nets: ['BNB Chain'] },
  { s: 'DMAIL', n: 'Dmail Network', i: 'DmailNetworkDMAIL.png', nets: ['BNB Chain'] },
  { s: 'DPR', n: 'Deeper Network', i: 'DeeperNetworkDPR.png', nets: ['BNB Chain'] },
  { s: 'ERTHA', n: 'Ertha', i: 'ErthaERTHA.png', nets: ['BNB Chain'] },
  { s: 'GAFI', n: 'GameFi', i: 'GamefiGAFI.png', nets: ['BNB Chain'] },
  { s: 'RIO', n: 'Realio Network', i: 'RealioNetworkRIO.png', nets: ['BNB Chain'] },
  { s: 'TLM', n: 'Alien Worlds', i: 'AlienWorldsTLM.svg', nets: ['BNB Chain'] },
  { s: 'TLOS', n: 'Telos', i: 'TelosTLOS.svg', nets: ['BNB Chain'] },
  { s: 'TOKEN', n: 'TokenFi', i: 'TokenfiTOKEN.png', nets: ['BNB Chain'] },
  { s: 'BTC', n: 'Bitcoin', i: 'BitcoinBTC.svg', nets: ['Bitcoin'] },
  { s: 'DASH', n: 'Dash', i: 'DashDASH.svg', nets: ['Dash'] },
  { s: 'DOGE', n: 'Dogecoin', i: 'DogecoinDOGE.svg', nets: ['Dogecoin'] },
  { s: 'AAVE', n: 'Aave', i: 'AaveAAVE.svg', nets: ['Ethereum'] },
  { s: 'ACH', n: 'Alchemy Pay', i: 'AlchemyPayACH.png', nets: ['Ethereum'] },
  { s: 'AIOZ', n: 'AIOZ Network', i: 'AiozNetworkAIOZ.png', nets: ['Ethereum'] },
  { s: 'AMP', n: 'Amp', i: 'AmpAMP.svg', nets: ['Ethereum'] },
  { s: 'ANKR', n: 'Ankr', i: 'AnkrANKR.svg', nets: ['Ethereum'] },
  { s: 'APE', n: 'ApeCoin', i: 'ApecoinAPE.png', nets: ['Ethereum'] },
  { s: 'AXS', n: 'Axie Infinity', i: 'AxieInfinityAXS.svg', nets: ['Ethereum'] },
  { s: 'CHZ', n: 'Chiliz', i: 'ChilizCHZ.svg', nets: ['Ethereum'] },
  { s: 'COMP', n: 'Compound', i: 'CompoundCOMP.svg', nets: ['Ethereum'] },
  { s: 'COTI', n: 'COTI', i: 'COTICOTI.svg', nets: ['Ethereum'] },
  { s: 'CRO', n: 'Cronos', i: 'CryptoComCoinCRO.svg', nets: ['Ethereum'] },
  { s: 'CRV', n: 'Curve DAO', i: 'CurveDAOTokenCRV.svg', nets: ['Ethereum'] },
  { s: 'CVX', n: 'Convex Finance', i: 'ConvexFinanceCVX.png', nets: ['Ethereum'] },
  { s: 'ENA', n: 'Ethena', i: 'EthenaENA.png', nets: ['Ethereum'] },
  { s: 'ENS', n: 'Ethereum Name Service', i: 'EthereumNameServiceENS.png', nets: ['Ethereum'] },
  { s: 'ETHFI', n: 'Ether.fi', i: 'EtherFiETHFI.png', nets: ['Ethereum'] },
  { s: 'FLOKI', n: 'Floki', i: 'FlokiFLOKI.png', nets: ['Ethereum'] },
  { s: 'GRT', n: 'The Graph', i: 'TheGraphGRT.svg', nets: ['Ethereum'] },
  { s: 'IMX', n: 'Immutable', i: 'ImmutableIMX.png', nets: ['Ethereum'] },
  { s: 'JASMY', n: 'JasmyCoin', i: 'JasmycoinJASMY.png', nets: ['Ethereum'] },
  { s: 'LDO', n: 'Lido DAO', i: 'LidoDAOTokenLDO.svg', nets: ['Ethereum'] },
  { s: 'LINK', n: 'Chainlink', i: 'ChainlinkLINK.svg', nets: ['Ethereum'] },
  { s: 'LRC', n: 'Loopring', i: 'LoopringLRC.svg', nets: ['Ethereum'] },
  { s: 'MNT', n: 'Mantle', i: 'MantleMNT.png', nets: ['Ethereum'] },
  { s: 'OM', n: 'MANTRA', i: 'MANTRADAOOM.svg', nets: ['Ethereum'] },
  { s: 'ONDO', n: 'Ondo', i: 'OndoONDO.png', nets: ['Ethereum'] },
  { s: 'PAXG', n: 'PAX Gold', i: 'PAXGoldPAXG.svg', nets: ['Ethereum'] },
  { s: 'PENDLE', n: 'Pendle', i: 'PendlePENDLE.png', nets: ['Ethereum'] },
  { s: 'PEPE', n: 'Pepe', i: 'PepePEPE.png', nets: ['Ethereum'] },
  { s: 'POL', n: 'Polygon', i: 'PolygonMATIC.svg', nets: ['Ethereum', 'Polygon'] },
  { s: 'QNT', n: 'Quant', i: 'QuantQNT.svg', nets: ['Ethereum'] },
  { s: 'RSR', n: 'Reserve Rights', i: 'ReserveRightsRSR.svg', nets: ['Ethereum'] },
  { s: 'SAFE', n: 'Safe', i: 'SafeSAFE.png', nets: ['Ethereum'] },
  { s: 'SAND', n: 'The Sandbox', i: 'TheSandboxSAND.svg', nets: ['Ethereum'] },
  { s: 'SHIB', n: 'Shiba Inu', i: 'SHIBAINUSHIB.svg', nets: ['Ethereum'] },
  { s: 'SKL', n: 'SKALE', i: 'SKALENetworkSKL.svg', nets: ['Ethereum'] },
  { s: 'SOLAXY', n: 'Solaxy', i: 'SolaxySOLAXY.png', nets: ['Ethereum'] },
  { s: 'SUPER', n: 'SuperVerse', i: 'SuperFarmSUPER.svg', nets: ['Ethereum'] },
  { s: 'SUSHI', n: 'SushiSwap', i: 'SushiSwapSUSHI.svg', nets: ['Ethereum'] },
  { s: 'SWFTC', n: 'SWFT Blockchain', i: 'SwftBlockchainSWFTC.png', nets: ['Ethereum'] },
  { s: 'UNI', n: 'Uniswap', i: 'UniswapUNI.svg', nets: ['Ethereum'] },
  { s: 'VENOM', n: 'Venom', i: 'VenomVENOM.png', nets: ['Ethereum'] },
  { s: 'WLD', n: 'Worldcoin', i: 'WorldcoinWLD.png', nets: ['Ethereum'] },
  { s: 'XCN', n: 'Onyxcoin', i: 'OnyxcoinXCN.png', nets: ['Ethereum'] },
  { s: 'YFI', n: 'yearn.finance', i: 'YearnFinanceYFI.svg', nets: ['Ethereum'] },
  { s: 'LTC', n: 'Litecoin', i: 'LitecoinLTC.svg', nets: ['Litecoin'] },
  { s: 'BOME', n: 'Book of Meme', i: 'BookOfMemeBOME.png', nets: ['Solana'] },
  { s: 'BONK', n: 'Bonk', i: 'BonkBONK.png', nets: ['Solana'] },
  { s: 'CRCLX', n: 'CRCLX', i: '', nets: ['Solana'] },
  { s: 'HNT', n: 'Helium', i: 'HeliumHNT.svg', nets: ['Solana'] },
  { s: 'JTO', n: 'Jito', i: 'JitoJTO.png', nets: ['Solana'] },
  { s: 'JUP', n: 'Jupiter', i: 'JupiterJUP.png', nets: ['Solana'] },
  { s: 'LIKE', n: 'LIKE', i: '', nets: ['Solana'] },
  { s: 'MEW', n: 'Cat in a Dogs World', i: 'CatInADogsWorldMEW.png', nets: ['Solana'] },
  { s: 'ORCA', n: 'Orca', i: 'OrcaORCA.png', nets: ['Solana'] },
  { s: 'PRCL', n: 'Parcl', i: 'ParclPRCL.png', nets: ['Solana'] },
  { s: 'PYTH', n: 'Pyth Network', i: 'PythNetworkPYTH.png', nets: ['Solana'] },
  { s: 'RAY', n: 'Raydium', i: 'RaydiumRAY.svg', nets: ['Solana'] },
  { s: 'SAROS', n: 'Saros', i: 'SarosSAROS.png', nets: ['Solana'] },
  { s: 'SOL', n: 'Solana', i: 'SolanaSOL.svg', nets: ['Solana'] },
  { s: 'WIF', n: 'dogwifhat', i: 'DogwifhatWIF.png', nets: ['Solana'] },
  { s: 'ZBCN', n: 'Zebec Network', i: 'ZebecNetworkZBCN.png', nets: ['Solana'] },
  { s: 'ZEUS', n: 'Zeus Network', i: 'ZeusNetworkZEUS.png', nets: ['Solana'] },
  { s: 'HMSTR', n: 'Hamster Kombat', i: 'HamsterKombatHMSTR.png', nets: ['TON'] },
  { s: 'NOT', n: 'Notcoin', i: 'NotcoinNOT.png', nets: ['TON'] },
  { s: 'TON', n: 'Gram', i: 'GramTON.svg', nets: ['TON'] },
  { s: 'JST', n: 'JUST', i: 'JUSTJST.svg', nets: ['Tron'], soon: 1 },
  { s: 'NFT', n: 'APENFT', i: 'APENFTNFT.svg', nets: ['Tron'], soon: 1 },
  { s: 'SUN', n: 'Sun', i: 'SunSUN.png', nets: ['Tron'], soon: 1 },
  { s: 'TRX', n: 'Tron', i: 'TRONTRX.svg', nets: ['Tron'] },
  { s: 'XMR', n: 'Monero', i: 'MoneroXMR.svg', nets: ['Monero'] },
];

function esc(s) {
  return String(s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
  }[c]));
}

// Сети по убыванию числа монет, затем A–Z.
function networkOrder() {
  const counts = {};
  COINS.forEach((c) => c.nets.forEach((n) => { counts[n] = (counts[n] || 0) + 1; }));
  return Object.keys(counts).sort((a, b) => counts[b] - counts[a] || a.localeCompare(b));
}

export function initCoinsCatalog() {
  const gridEl = document.getElementById('coinsGrid');
  if (!gridEl) return;

  const emptyEl = document.getElementById('coinsEmpty');
  const countEl = document.getElementById('coinsCount');
  const filtersEl = document.getElementById('coinsFilters');
  const searchEl = document.getElementById('coinsSearch');
  const modalEl = document.getElementById('modalCoins');

  const allLabel = (modalEl && modalEl.dataset.tAll) || 'All';
  const soonLabel = (modalEl && modalEl.dataset.tSoon) || 'Soon';

  const state = { q: '', net: '' };

  function coinHTML(c) {
    const media = c.i
      ? `<span class="coin-cell__icon"><img src="${ICON_BASE}${esc(c.i)}" alt="${esc(c.n)}" loading="lazy" width="34" height="34" /></span>`
      : `<span class="coin-mono" aria-hidden="true">${esc(c.s.slice(0, 4))}</span>`;
    const soon = c.soon ? `<span class="coin-soon">${esc(soonLabel)}</span>` : '';
    const nets = c.nets.map((n) => `<span class="coin-net">${esc(n)}</span>`).join('');
    return `<div class="coin-cell">${media}<div class="coin-cell__meta">`
      + `<div class="coin-cell__top"><span class="coin-cell__name">${esc(c.n)}</span>`
      + `<span class="coin-cell__sym">${esc(c.s)}</span>${soon}</div>`
      + `<div class="coin-cell__nets">${nets}</div></div></div>`;
  }

  function matches(c) {
    if (state.net && c.nets.indexOf(state.net) === -1) return false;
    if (state.q) {
      const hay = `${c.n} ${c.s} ${c.nets.join(' ')}`.toLowerCase();
      if (hay.indexOf(state.q) === -1) return false;
    }
    return true;
  }

  function render() {
    const list = COINS.filter(matches);
    gridEl.innerHTML = list.map(coinHTML).join('');
    if (countEl) countEl.textContent = `${list.length} / ${COINS.length}`;
    if (emptyEl) emptyEl.hidden = list.length > 0;
  }

  function setChipActive(btn, active) {
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function buildFilters() {
    if (!filtersEl) return;
    const chips = [`<button type="button" class="coins-chip" data-net="" aria-pressed="false">${esc(allLabel)}</button>`];
    networkOrder().forEach((n) => {
      chips.push(`<button type="button" class="coins-chip" data-net="${esc(n)}" aria-pressed="false">${esc(n)}</button>`);
    });
    filtersEl.innerHTML = chips.join('');
    filtersEl.querySelectorAll('.coins-chip').forEach((btn) => {
      setChipActive(btn, btn.getAttribute('data-net') === state.net);
      btn.addEventListener('click', () => {
        state.net = btn.getAttribute('data-net');
        filtersEl.querySelectorAll('.coins-chip').forEach((b) => setChipActive(b, b === btn));
        render();
      });
    });
  }

  function resetState() {
    state.q = '';
    state.net = '';
    if (searchEl) searchEl.value = '';
    buildFilters();
    render();
  }

  buildFilters();
  render();

  if (searchEl) {
    searchEl.addEventListener('input', () => {
      state.q = searchEl.value.trim().toLowerCase();
      render();
    });
  }

  if (modalEl) {
    // Свежее состояние при каждом открытии; фокус на поиск.
    modalEl.addEventListener('hidden.bs.modal', resetState);
    modalEl.addEventListener('shown.bs.modal', () => {
      if (searchEl) searchEl.focus();
    });
  }
}
